import React, {useState, useContext} from "react";

import {View, Text, BackHandler}  from 'react-native'

import contexto from '../util/contexto'

import {estilos} from '../util/estilos'

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import { useFocusEffect } from '@react-navigation/native';

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import Botao from '../componentes/Botao'

import {buscarPropostas as wsBuscarPropostas} from '../ws/ws_propostas'

import {carregamento} from '../componentes/Carregamento'

import {semDados} from '../componentes/SemDados'

import * as numeros from '../util/numeros'

import * as data from '../util/data'

import {TIPO_NOTIF_PPT_NOVA, TIPO_NOTIF_PRPTA_CANCEL, TELA_MEUS_PEDIDOS, TELA_DETALHE_PROPOSTA, TELA_PROPOSTAS_MEU_PEDIDO, TELA_CHAT} from '../util/constantes'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import Combo from '../componentes/Combo'



export default function TelaPropostasMeuPedido(){

	const {valorContexto, setValorContexto} = useContext(contexto);

	const navegacao = new useNavigation();

	const [sincronizando, setSincronizando] = useState(true) 
	
	const FILTRO_ORDENAR_VALOR = 7;
	const FILTRO_ORDENAR_PRAZO_ENTREGA = 17;
	const FILTRO_ORDENAR_VALOR_FRETE = 27;
	
	const [filtro, setFiltro] = useState(FILTRO_ORDENAR_VALOR)  
   
	const [listaPropostas, setListaPropostas] = useState([])
	
	

	const voltar = () => {
			
		navegacao.replace(util.processaVoltar())
		return true;
	};

	
	useFocusEffect(React.useCallback(() => {

		util.print("TelaPropostasMeuPedido");

		BackHandler.addEventListener('hardwareBackPress', voltar);
		
		buscarPropostas();
		
		return () => {
			BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	
	
	const buscarPropostas= async ()=>{

		console.log('TelaPropostasMeuPedido - buscando propostas');

		setSincronizando(true)

		let itens  = await wsBuscarPropostas(valorContexto.idPedido, null);
   
		if(util.temConteudo(itens))
			setListaPropostas(util.ordenar(itens, "valor"));
		
		let atualizarMsg = false;
		
		setSincronizando(false)
	}


	const verProposta= async (id_proposta)=>{

		console.log("verProposta "+id_proposta);
		
		setValorContexto(prevState =>({...prevState, idProposta: id_proposta}));
	
		util.setVoltar(TELA_PROPOSTAS_MEU_PEDIDO);

		navegacao.navigate(TELA_DETALHE_PROPOSTA);
	}


	function abrirChat(id_chat, id_proposta){
		
		console.log("chat");
		
		setValorContexto(prevState =>({...prevState, idChat: id_chat}));

		setValorContexto(prevState =>({...prevState, idProposta: id_proposta}));
		
		util.setVoltar(TELA_PROPOSTAS_MEU_PEDIDO);

		navegacao.navigate(TELA_CHAT);
	}

	
	function mudouFiltro(novoFiltro){
		
		setFiltro(novoFiltro);
		
		if(novoFiltro==FILTRO_ORDENAR_VALOR)
			setListaPropostas(util.ordenar(listaPropostas, "valor"))
		
		if(novoFiltro==FILTRO_ORDENAR_PRAZO_ENTREGA)
			setListaPropostas(util.ordenar(listaPropostas, "prazo_entrega"))
		
		if(novoFiltro==FILTRO_ORDENAR_VALOR_FRETE)
			setListaPropostas(util.ordenar(listaPropostas, "valor_frete"))
	}


	return (

		(<ViewDegradeVertical titulo="Propostas Recebidas" voltar={()=>voltar()}>  
			<Scroll>
				{(sincronizando) ?
					(carregamento(sincronizando)):
					(util.temConteudo(listaPropostas)) ?
						(<View style={{flex:1}}>
							<Bloco podeRecolher={true}> 
								<View style={{marginTop:10}}/> 
								
								<Combo 
									rotulo="Ordenar por:" 
									selecionado={FILTRO_ORDENAR_VALOR} 
									dados={[{"nome": "Valor Proposta", "id": FILTRO_ORDENAR_VALOR}, 
												{"nome": "Prazo de entrega", "id": FILTRO_ORDENAR_PRAZO_ENTREGA},
													{"nome": "Valor Frete", "id": FILTRO_ORDENAR_VALOR_FRETE}]}
									aoMudar={(valor)=>mudouFiltro(valor.id)}/>
							</Bloco>
							
								{listaPropostas.map((item, index) => itemLista(item, index))}
							
						</View>):
						(<Bloco todaArea={true}> 
							{semDados("info", "Nenhum proposta de orçamento recebida.", 60)}
						</Bloco>)
						
				}
			</Scroll>
		</ViewDegradeVertical>)
	);


	function itemLista(item, index){

		return (
			<Bloco key={index}> 
				<View style={{marginTop:5}}/>
				
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}> 
						<Text style={estilos.rotulo_menor}>Proponente: {item.nome_proponente}</Text>			
					</View>
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
						<Text style={estilos.rotulo_menor}>Enviado em: {data.converteDataEuaParaBr(item.data_criacao)}</Text>
					</View>
				</View>
				<View style={{marginTop:10}}/>
				<Text style={estilos.rotulo_padrao}>{util.substring(item.descricao, 100)}</Text>
				
				<Text style={estilos.rotulo_titulo}>Valor Total (R$): {numeros.formataNumeroParaMostrar(item.valor)}</Text>
				
				<Text style={estilos.rotulo_padrao}>Prazo de Entrega (em dias): {item.prazo_entrega ==null?"Nao informado":item.prazo_entrega}</Text>
				
				<Text style={estilos.rotulo_padrao}>Valor Frete (R$): {item.valor_frete ==null?"Nao informado":numeros.formataNumeroParaMostrar(item.valor_frete)}</Text>
			
				<View style={{marginTop:25}}/>
				
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
						<Botao 
							acao={()=>verProposta(item.id)}
							texto="Detalhar"/>   
					</View>
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
						<Botao 
							acao={()=>abrirChat(item.fk_chat, item.id)}
							texto="Mensagens"/> 								
					</View>
				</View>
				<View style={{marginTop:5}}/>
			</Bloco>	
		)
	}


}